module.exports = __webpack_public_path__ + "static/media/LiveView1.3112b37f.webp";